import { Canvas, extend } from '@react-three/fiber';
import {Center, Environment, OrbitControls} from '@react-three/drei';
import { useControls, buttonGroup } from 'leva';
import { useState, Suspense } from 'react';
import * as THREE from 'three/webgpu';
import EsempioProcedurale from './EsempioProcedurale';
import PianoSalvagoccia from './PianoSalvagoccia';

// Registra nel catalogo di R3F tutte le classi (incluse quelle WebGPU/node).
extend(THREE);

export default function CubeScene() {
  const [esempio, setEsempio] = useState(1);

  const env = {
    file: "/images/environments/studio_kontrast_04_2k_blur.hdr",
    intensity: 0.75,
    background: false,
    rotX: 1.52,
    rotY: 1.0,
    rotZ: 1.78,
  }

  useControls('Esempi', {
    visualizza: buttonGroup({
      label: 'Visualizza',
      opts: {
        'Esempio 1': () => setEsempio(1),
        'Esempio 2': () => setEsempio(2),
      },
    }),
  });

  return (
    <>
      <Canvas
        style={{ width: '100%', height: '100%' }}
        camera={{ position: [0, 80, 160], fov: 50 }}
        gl={async (glProps) => {
          const renderer = new THREE.WebGPURenderer({
            ...glProps,
            alpha: true,
            antialias: true,
            powerPreference: 'high-performance',
          });
          await renderer.init();
          renderer.toneMapping = THREE.NoToneMapping;
          return renderer;
        }}
        dpr={[1, 2]}
        performance={{ min: 0.5 }}
      >
        <Environment
          files={env.file}
          background={env.background}
          environmentIntensity={env.intensity}
          environmentRotation={[env.rotX, env.rotY, env.rotZ]}
        />
        <OrbitControls />
        <ambientLight intensity={0.6} />
        <directionalLight position={[0, 2, 0]} intensity={1} />

        {esempio === 1 && <EsempioProcedurale />}

        {esempio === 2 && (
          <Suspense fallback={null}>
            <Center>
              <PianoSalvagoccia />
            </Center>
          </Suspense>
        )}
      </Canvas>
    </>
  );
}
